export class DataBinder<T = Record<string, any>> {
    content: T;
    changeSet?: T;
    callback?: (dataBinder: DataBinder<T>) => void;
    hasChanges = false;
    save?: () => Promise<unknown>;

    constructor(content?: T, callback?: DataBinder<T>['callback']) {
        if (!content) {
            this.content = {} as T;
        } else if (typeof content === 'string') {
            this.content = JSON.parse(content);
        } else {
            this.content = content;
        }
        this.callback = callback;
        this.update(this.content);
    }
    getRawContent() {
        const content = this.content;
        if (this.changeSet) {
            Object.assign(content, this.changeSet);
        }
        return content;
    }
    update(source) {
        this.changeSet = {} as T;
        Object.assign(this.changeSet, source);
        this.hasChanges = false;
    }
    bind(property: T extends Record<string, unknown> ? keyof T : string) {
        const self = this;
        const prop = property as string;
        return {
            dataBinder: this,
            property: property,
            updateValue: (val) => {
                self.updateProperty(property, val);
            },
            getValue: () => {
                const propSplit = prop.split('.');
                if (propSplit.length > 1) {
                    let targetObject = self.changeSet;
                    const sub_prop = prop.replace(propSplit[0] + '.', '');

                    targetObject = targetObject
                        ? targetObject[propSplit[0]][sub_prop]
                        : undefined;

                    if (!targetObject) return '';
                    return targetObject;
                }

                return self.changeSet ? self.changeSet[prop] : undefined;
            },
        };
    }
    updateProperty(property, val) {
        const self = this;
        let content = self.changeSet;
        self.hasChanges = true;

        const propSplit = property.split('.');
        if (!content) content = {} as T;

        if (propSplit.length > 1) {
            const sub_prop = property.replace(propSplit[0] + '.', '');
            content[propSplit[0]][sub_prop] = val;
        } else {
            content[property] = val;
        }

        if (self.callback) self.callback(self);
    }
    getChanges() {
        if (!this.hasChanges) return null;

        const changes = this.changeSet;

        this.hasChanges = false;

        return changes;
    }
}
